<template>
  <el-dialog
    :title="locationName || '位置'"
    :visible.sync="dialogVisible"
    width="800px"
    top="10vh"
    :close-on-click-modal="true"
    @closed="onClosed"
  >
    <div class="location-viewer-container">
      <div class="location-info-bar">
        <i class="el-icon-location-information"></i>
        <div class="info-content">
          <div class="location-name">{{ locationName || '未知位置' }}</div>
          <div class="location-address">{{ locationAddress || '无详细地址' }}</div>
        </div>
      </div>
      <div class="map-wrapper">
        <div id="tencent-location-viewer" class="map-canvas"></div>
      </div>
      <div class="coord-info" v-if="latitude && longitude">
        坐标：{{ latitude.toFixed(6) }}, {{ longitude.toFixed(6) }}
      </div>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="openInBrowser">在浏览器中打开</el-button>
    </div>
  </el-dialog>
</template>

<script>
/* global TMap */
const MAP_KEY = 'JJLBZ-BQHYG-YK5QF-QYADS-ARWOE-ICBOQ'

export default {
  name: 'LocationViewer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    latitude: {
      type: Number,
      default: null
    },
    longitude: {
      type: Number,
      default: null
    },
    locationName: {
      type: String,
      default: ''
    },
    locationAddress: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      map: null,
      marker: null
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.$nextTick(() => {
          this.initMap()
        })
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  beforeDestroy() {
    this.cleanupMap()
  },
  methods: {
    initMap() {
      if (typeof TMap === 'undefined') {
        console.error('腾讯地图 TMap API 未加载')
        this.$message.error('地图加载失败，请刷新页面重试')
        return
      }

      const lat = this.latitude || 30.572816
      const lng = this.longitude || 114.27719

      this.map = new TMap.Map('tencent-location-viewer', {
        center: new TMap.LatLng(lat, lng),
        zoom: 16,
        mapStyleId: 'style1'
      })

      this.addMarker(lat, lng)
    },
    cleanupMap() {
      if (this.marker) {
        this.marker.setMap(null)
        this.marker = null
      }
      if (this.map) {
        this.map = null
      }
    },
    addMarker(lat, lng) {
      if (!this.map) return

      const svgIcon = 'data:image/svg+xml;base64,' + btoa(`
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40">
          <path d="M15 0C6.716 0 0 6.716 0 15c0 10.5 15 25 15 25s15-14.5 15-25C30 6.716 23.284 0 15 0z" fill="#e53e3e"/>
          <circle cx="15" cy="15" r="6" fill="white"/>
        </svg>
      `)

      this.marker = new TMap.MultiMarker({
        map: this.map,
        styles: {
          marker: new TMap.MarkerStyle({
            width: 30,
            height: 40,
            anchor: { x: 15, y: 40 },
            src: svgIcon
          })
        },
        geometries: [{
          id: 'marker',
          styleId: 'marker',
          position: new TMap.LatLng(lat, lng)
        }]
      })
    },
    onClosed() {
      this.cleanupMap()
    },
    openInBrowser() {
      if (this.latitude && this.longitude) {
        const url = `https://lbs.qq.com/miniProgram/jsSdk/jsSdkGuide/method-openlocation?lat=${this.latitude}&lng=${this.longitude}&coord_type=GCJ02`
        window.open(url, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.location-viewer-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.location-info-bar {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 8px;
  gap: 12px;
}

.location-info-bar i {
  font-size: 28px;
  color: #409eff;
  flex-shrink: 0;
}

.info-content {
  flex: 1;
}

.location-name {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
  margin-bottom: 4px;
}

.location-address {
  font-size: 14px;
  color: #909399;
  word-break: break-all;
}

.map-wrapper {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ebeef5;
}

.map-canvas {
  width: 100%;
  height: 400px;
}

.coord-info {
  font-size: 12px;
  color: #c0c4cc;
  text-align: right;
}
</style>
